/**
 * テーブルドラッグスクロール機能
 * 全てのテーブルラッパーにドラッグ&ドロップでスクロール機能を提供
 */
document.addEventListener('DOMContentLoaded', function() {
    // ドラッグスクロールを適用するセレクター
    const tableSelectors = [
        '.table-wrapper',
        '.condition-table-wrapper',
        '.normal-table-wrapper',
        '.scrollable-table',
        '.data-table-wrapper'
    ];

    // 各セレクターのテーブルラッパーに機能を適用
    tableSelectors.forEach(selector => {
        const tableWrappers = document.querySelectorAll(selector);
        tableWrappers.forEach(tableWrapper => {
            initDragScroll(tableWrapper);
        });
    });

    /**
     * ドラッグスクロール機能を初期化
     * テキスト上ではコピー可能、空白部分ではドラッグスクロールを有効化
     * @param {HTMLElement} tableWrapper テーブルラッパー要素
     */
    function initDragScroll(tableWrapper) {
        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;

        // マウスダウンイベント
        tableWrapper.addEventListener('mousedown', function(e) {
            const target = e.target;
            const table = tableWrapper.querySelector('table');
            
            // テーブル内の要素をクリックした場合はテキスト選択を許可
            if (table && table.contains(target)) {
                // テキスト選択を許可（preventDefaultを呼ばない）
                isDragging = false;
                // preventDefaultを呼ばないことで、通常のテキスト選択を許可
                return;
            }
            
            // テーブルラッパー自体をクリックした場合のみドラッグスクロールを開始
            if (target === tableWrapper) {
                isDragging = true;
                tableWrapper.style.cursor = 'grabbing';
                tableWrapper.style.userSelect = 'none';
                startX = e.pageX - tableWrapper.offsetLeft;
                scrollLeft = tableWrapper.scrollLeft;
                e.preventDefault();
            } else {
                // その他の要素（スクロールインジケーターなど）の場合はテキスト選択を許可
                isDragging = false;
            }
        });

        // マウスムーブイベント
        tableWrapper.addEventListener('mousemove', function(e) {
            const target = e.target;
            const table = tableWrapper.querySelector('table');
            
            if (!isDragging) {
                // ドラッグ中でない場合、カーソルを更新
                if (table && table.contains(target)) {
                    // テーブル内の要素の場合はテキストカーソル
                    tableWrapper.style.cursor = 'text';
                } else if (target === tableWrapper) {
                    // テーブルラッパー自体の場合はgrabカーソル
                    tableWrapper.style.cursor = 'grab';
                } else {
                    tableWrapper.style.cursor = 'default';
                }
                return;
            }
            
            // テキストが選択されている場合は、ドラッグスクロールを無効化
            const selection = window.getSelection();
            if (selection && selection.toString().length > 0) {
                isDragging = false;
                tableWrapper.style.cursor = 'text';
                return;
            }
            
            // テーブル内の要素にマウスが移動した場合はドラッグを停止
            if (table && table.contains(target)) {
                isDragging = false;
                tableWrapper.style.cursor = 'text';
                return;
            }
            
            e.preventDefault();
            const x = e.pageX - tableWrapper.offsetLeft;
            const walk = (x - startX) * 2; // スクロール速度調整
            tableWrapper.scrollLeft = scrollLeft - walk;
        });

        // マウスアップイベント
        tableWrapper.addEventListener('mouseup', function(e) {
            isDragging = false;
            // カーソルをマウスムーブで更新されるようにする
            const target = e.target;
            const table = tableWrapper.querySelector('table');
            if (table && table.contains(target)) {
                tableWrapper.style.cursor = 'text';
            } else {
                tableWrapper.style.cursor = 'default';
            }
        });

        // マウスリーブイベント
        tableWrapper.addEventListener('mouseleave', function() {
            isDragging = false;
            tableWrapper.style.cursor = 'default';
        });

        // 初期カーソル設定
        tableWrapper.style.cursor = 'default';
        // テーブルラッパー自体はuserSelectをnoneにしない（テーブル内の要素の選択を許可）
        
        // テーブル内の要素にuserSelectを明示的に設定
        const table = tableWrapper.querySelector('table');
        if (table) {
            // テーブル全体とすべての子要素にuserSelectを設定
            table.style.userSelect = 'text';
            table.style.webkitUserSelect = 'text';
            table.style.mozUserSelect = 'text';
            table.style.msUserSelect = 'text';
            
            // すべてのセルに明示的に設定
            const cells = table.querySelectorAll('td, th');
            cells.forEach(cell => {
                cell.style.userSelect = 'text';
                cell.style.webkitUserSelect = 'text';
                cell.style.mozUserSelect = 'text';
                cell.style.msUserSelect = 'text';
            });
        }

        // タッチイベント対応（モバイル）
        let touchStartX = 0;
        let touchScrollLeft = 0;

        tableWrapper.addEventListener('touchstart', function(e) {
            touchStartX = e.touches[0].pageX;
            touchScrollLeft = tableWrapper.scrollLeft;
        });

        tableWrapper.addEventListener('touchmove', function(e) {
            if (!touchStartX) return;
            const touchX = e.touches[0].pageX;
            const walk = (touchStartX - touchX) * 1.5; // タッチスクロール速度調整
            tableWrapper.scrollLeft = touchScrollLeft + walk;
        });

        tableWrapper.addEventListener('touchend', function() {
            touchStartX = 0;
        });
    }

});
